import { render, staticRenderFns } from "./BlockCalendar.vue?vue&type=template&id=8b24ae68&scoped=true&"
import script from "./BlockCalendar.vue?vue&type=script&lang=js&"
export * from "./BlockCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BlockCalendar.vue?vue&type=style&index=0&id=8b24ae68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b24ae68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VExpandTransition,VHover,VIcon,VRow,VSheet})
